import { render, staticRenderFns } from "./BrandingLogo.vue?vue&type=template&id=75106ddc&"
import script from "./BrandingLogo.vue?vue&type=script&lang=js&"
export * from "./BrandingLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports